$(document).ready(function(){
  setupOrderSummary();
})

function fetchJSON (url, config = {}) {
  const defaultConfig = {
    method: 'POST',
    headers: {
      Accept: `application/json`,
      'Content-Type': 'application/json',
    },
  }
  return fetch(
      url,
      Object.assign({}, defaultConfig, config),
      ).then(response => {
          if (!response.ok) {
              throw response
          }
          return response.json()
  })
}

async function getCart() {
  const config = {
    method: 'POST',
    headers: {
      Accept: `application/javascript`,
      'Content-Type': 'application/json',
    },
  }
  const cart = await fetchJSON('/cart.js', config)

  return cart
}

async function removeItem(href) {
  const config = {
    method: 'POST',
    headers: {
      Accept: `application/javascript`,
      'Content-Type': 'application/json',
    },
  }
  fetchJSON(href, config).then(data => {
    setTimeout(() => {
      let CartUpdated = new CustomEvent('theme:cartchanged',{ bubbles: true, cancelable: false })
      document.dispatchEvent(CartUpdated)
    }, 500)
  })
}

function setupOrderSummary() {
  const orderSummary = document.querySelector('.order-summary')

  getCartAndRenderOrderSummary()

  document.addEventListener('theme:cartchanged', function() {
    getCartAndRenderOrderSummary()
  })

  document.querySelector('.order-summary header').addEventListener('click', () => {
    orderSummary.ariaExpanded = orderSummary.ariaExpanded !== 'true'
  })
}

async function getCartAndRenderOrderSummary() {
  let cart = getCart()
  cart.then(cart => {
      renderOrderSummary(cart)
      refreshUploadKit()
    }
  )
}

function refreshUploadKit() {
  window.UploadKit.attributesScanned = true;
  var regex = new RegExp('https:\/\/cdn2?\.shopify\.com\/.*\?.*id=[^&]*&uu=([^&]*)&mo=([^&]*)&fi=([^&]*)(?:(?!&image).)*(&image=true)?', 'g');
  function acceptNode () {
    return NodeFilter.FILTER_ACCEPT;
  }
  function replaceUploadKitLinks(match, uuid, modifiers, filename, isImage) {
    if(isImage) {
      return '<a href="https://cdn.getuploadkit.com/' + uuid + '/' + modifiers + '-/preview/1200x1200" class="uploadkit-preview-link-image" title="' + atob(filename) + '"><img src="https://cdn.getuploadkit.com/' + uuid + '/' + modifiers + '-/resize/300x/" style="max-width: 50px; max-height: 50px; vertical-align: middle;" /></a>';
    } else {
      return '<a href="https://cdn.getuploadkit.com/' + uuid + '/' + '" class="uploadkit-preview-link">' + atob(filename) + '</a>'
    }
  }
  // Work around Internet Explorer wanting a function instead of an object.
  // IE also *requires* this argument where other browsers don't.
  var filter = acceptNode;
  filter.acceptNode = acceptNode;
  var treeWalker = document.createTreeWalker(document.body, NodeFilter.SHOW_ALL, filter, false);
  var foundNodes = [];
  while (treeWalker.nextNode()) {
    var node = treeWalker.currentNode;
    regex.lastIndex = 0;
    if(node.nodeType === 3 && regex.exec(node.textContent)) {
      foundNodes.push(node);
    }
    if(node.nodeType === 3 && node.textContent.indexOf('_') > -1) {
      for(var i = 0; i < window.UploadKit.config.uploaders.length; i++) {
        node.textContent = node.textContent.replace('_' + window.UploadKit.config.uploaders[i].name, window.UploadKit.config.uploaders[i].name);
      }
    }
  }
  for(var i = 0; i < foundNodes.length; i++) {
    var node = foundNodes[i];
    regex.lastIndex = 0;
    var match = regex.exec(node.textContent);
    if(match) {
      var replacementNode = document.createElement('span');
      replacementNode.innerHTML = node.textContent.replace(regex, replaceUploadKitLinks);
      /*if(match[4]) {
        // ?image
        replacementNode.innerHTML = node.textContent.replace(regex, '<a href="https://cdn.getuploadkit.com/' + '$1/$2-/preview/1200x1200" class="uploadkit-preview-link-image" title="$3"><img src="https://cdn.getuploadkit.com/$1/$2-/resize/300x/" style="max-width: 50px; max-height: 50px; vertical-align: middle;" /></a>');
      } else {
        replacementNode.innerHTML = node.textContent.replace(regex, '<a href="https://cdn.getuploadkit.com/' + '$1/$2" class="uploadkit-preview-link">$3</a>');
      }*/
      node.parentNode.insertBefore(replacementNode, node);
      node.parentNode.removeChild(node);
    }
  }
  if(foundNodes.length > 0) {
    var lightboxStyles = document.createElement("link");
    lightboxStyles.type = "text/css";
    lightboxStyles.rel = "stylesheet";
    lightboxStyles.href = 'https://assets.getuploadkit.com/assets/luminous.css';
    document.head.appendChild(lightboxStyles);
    var lightboxScript = document.createElement('script');
    lightboxScript.type = 'text/javascript';
    lightboxScript.async = false;
    lightboxScript.src = 'https://assets.getuploadkit.com/assets/luminous.js';
    document.head.appendChild(lightboxScript);
    lightboxScript.onload = function() {
        new LuminousGallery(document.querySelectorAll('a.uploadkit-preview-link-image'));
    }
  }
}


async function renderOrderSummary(cart) {
  const orderSummaryItemsContainer = document.querySelector('.order-summary-items')


  let orderSummaryItems = ``
  if (cart.items.length) {
    for (i = 0; i < cart.items.length; i++) {
      let item = cart.items[i]
      if (item.properties._boldBuilderId && !item.properties._boldVariantIds) continue
      orderSummaryItems += renderOrderSummaryItem(item,i)
    }


  } else {
    orderSummaryItems = "<span class='error-no-products'>Your cart is currently empty</span>"
  }

  orderSummaryItemsContainer.innerHTML = orderSummaryItems
  
  const listeners = setupListeners()
}

function renderOrderSummaryItem(item, index) {
  let orderSummaryItemHTML = ``

  orderSummaryItemHTML = `
    <div class="order-summary-item">
      <div class="order-summary-item--inner">
        <div class="order-summary-item--productMedia">
          <img src="${item.featured_image.url != null ? item.featured_image.url : ''}" alt="${item.featured_image.alt != null ? item.featured_image.alt : ''}" />
        </div>
        <div class="order-summary-item--details">
          <div class="list-view-item__title">
            <a href="${ item.url }" class="cart__product-title" data-cart-item-title>
              ${ item.product_title }
            </a>
          </div>
        `
  orderSummaryItemHTML += `
          <ul class="product-details">
  `
  item.options_with_values.forEach(option => {
    orderSummaryItemHTML += `
            <li class="product-details__item product-details__item--variant-option" data-cart-item-option>${ option.name }: ${ option.value }</li>
    `
  })
  orderSummaryItemHTML += `
            <span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_properties" style="display:none !important;"></span>
  `
  for (const [key, value] of Object.entries(item.properties)) {
    if (key[0] === '_') continue
    if (key.indexOf('pf') > -1) continue

    orderSummaryItemHTML += `
            <li class="product-details__item product-details__item--property" data-cart-item-property>
              <span class="product-details__item-label" data-cart-item-property-name>${ key }: </span>
              <span data-cart-item-property-value>
    `

    if (value.indexOf('/uploads/') > -1) {
      orderSummaryItemHTML += `
                <a href="${value}">
                  ${value.split('/')[1]}
                </a>
      `
    } else {
      orderSummaryItemHTML += `
                ${value}
      `
    }

    orderSummaryItemHTML += `
              </span>
            </li>
    `
  }
  orderSummaryItemHTML += `
          </ul>
          <div class="cart__actions">
            <p class="cart__edit">
              <a href="#" class="text-link text-link--accent" data-cart-edit data-modal-target="productModal_${item.product_id}" data-item-data="${btoa(JSON.stringify(item))}">
                Edit
              </a>
            </p>
            <p class="cart__duplicate">
              <a href="#" class="text-link text-link--accent" data-cart-duplicate data-modal-target="productModal_${item.product_id}" data-item-data="${btoa(JSON.stringify(item))}">
                Duplicate
              </a>
            </p>
            <p class="cart__remove">
              <a href="/cart/change?line=${index + 1}&amp;quantity=0" class="text-link text-link--accent" aria-label="remove ${item.product_title}" data-cart-remove>
                Remove
              </a>
            </p>
          </div>
  `
  
  orderSummaryItemHTML +=`
        </div>
        <div class="order-summary-item--price">
          <span class="price">$${item.final_line_price / 100}</span>
        </div>
      </div>
    </div>
  `
  
  return orderSummaryItemHTML
}

async function setupListeners() {
  const listeners = []
  
  const removeListener = document.querySelectorAll('[data-cart-remove]').forEach(remove => {
    remove.addEventListener('click', e => {
      e.preventDefault();
      const config = {
        method: 'POST',
        headers: {
          Accept: `application/javascript`,
          'Content-Type': 'application/json',
        },
      }
      let href = e.target.href

      removeItem(href)
    })
  })

  listeners.push(removeListener)

  const duplicateListener = document.querySelectorAll('[data-cart-duplicate]').forEach(duplicate => {
    duplicate.addEventListener('click', e => {
      e.preventDefault();

      let item = JSON.parse(atob(e.target.getAttribute('data-item-data')))
      let targetModal = document.querySelector('#' + e.target.getAttribute('data-modal-target'))

      prefillModal(targetModal, item)

      $(targetModal).modal()
    })
  })

  listeners.push(duplicateListener)

  const editListener = document.querySelectorAll('[data-cart-edit]').forEach(edit => {
    let removeNode = edit.parentNode.querySelector('[data-cart-remove]')
    edit.addEventListener('click', e => {
      e.preventDefault();

      let item = JSON.parse(atob(e.target.getAttribute('data-item-data')))
      let targetModal = document.querySelector('#' + e.target.getAttribute('data-modal-target'))

      prefillModal(targetModal, item)

      $(targetModal).modal()

      const removeNodeClickHandler = function() {
        removeNode.click()
      }

      $(targetModal).find('form').one('submit', removeNodeClickHandler)
      $(targetModal).one('hidden.bs.modal', function() {
        $(targetModal).find('form').off('submit', removeNodeClickHandler)
      })

      // On form submission remove the original item from the cart
    })
  })



  return listeners
}

function prefillModal(modal, item) {
  // for (i = 0; i < item.options_with_values.length; i++) {
  //   let option = item.options_with_values[i]
  //   let optionDOM = modal.querySelector(`.option-selector[data-option-index="${i}"] .opt-btn[value="${option.value}"]`)
  //   if (optionDOM){
  //     optionDOM.checked = true
  //   }
  // }
  for (const [key, value] of Object.entries(item.properties)) {
    if (key.indexOf('Uploaded File') > -1) continue
    if (key[0] === '_') continue
    if (key.indexOf('pf') > -1) continue
    console.log(key)
    console.log(value)
    let optionSwatch = modal.querySelector(`.bold_option_value_element:not(.bold_swatch_selected) input[type="checkbox"][value="${value}"]`)
    if (optionSwatch) {
      console.log(optionSwatch)
      console.log('click attempt...')
      optionSwatch.parentNode.click()
    }
    console.log('it did it')
  }
}